import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfoFullBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Info_full_blue"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8}
      fill="var(--color-surface-interactive-primary-default)"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      d="M11 6.2a1 1 0 1 1-1.999 0A1 1 0 0 1 11 6.2m-1.8 3a.8.8 0 1 1 1.6 0v4.4a.8.8 0 0 1-1.6 0z"
    />
  </svg>
);
export default SvgInfoFullBlue;
